import React from "react";
import { Wrapper } from "./PayHistory.styled";
import { Column } from "@ant-design/plots";
import { Row, Col, Collapse, Spin, Empty } from "components/common";
import { callGetApiWithAuth } from "utils/api";
import { useEffect } from "react";
import { useState } from "react";

const PayHistory = () => {
  const { Panel } = Collapse;

  const [payDate, setPayDate] = useState("");
  const [graphData, setGraphData] = useState([]);
  const [historyData, setHistoryData] = useState([]);
  const [currentData, setCurrentData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const mydate = () => {
    const hash = {},
      result = [];
    for (const { date, name, amount } of historyData) {
      if (!hash[date]) result.push((hash[date] = { date, name, amount: 0 }));
      hash[date].amount += +amount;
    }
    setCurrentData(result, hash);
  };

  useEffect(() => {
    if (historyData?.date == null) {
      mydate();
    }
  }, [historyData]);

  const onSuccessPayHistory = (data) => {
    setHistoryData(data);
  };

  const onFailPayHistory = (err) => {
    console.log(err);
  };

  const getPayHistory = () => {
    callGetApiWithAuth("getPayHistory", onSuccessPayHistory, onFailPayHistory);
  };

  const onSuccessGraphCall = (data) => {
    setGraphData(data);
  };

  const onFailGraphCall = (err) => {
    console.log(err);
  };

  const getMonthGraphApi = () => {
    callGetApiWithAuth("getMonthGraph", onSuccessGraphCall, onFailGraphCall);
  };

  const onSuccessPaytoDateCall = (data) => {
    setIsLoading(false);
    setPayDate(data);
  };

  const onFailPaytoDateCall = (err) => {
    setIsLoading(false);
    console.log(err);
  };

  const callGetPayToDateApi = () => {
    callGetApiWithAuth(
      "payToDate",
      onSuccessPaytoDateCall,
      onFailPaytoDateCall
    );
  };

  useEffect(() => {
    setIsLoading(true);
    getMonthGraphApi();
    callGetPayToDateApi();
    getPayHistory();
  }, []);

  const config = {
    height: 200,
    data: graphData,
    xField: "monthName",
    yField: "total",
    label: {
      style: {
        fill: "#FFFFFF",
        // opacity: 0.6,
      },
    },

    theme: {
      styleSheet: {
        brandColor: "#3a96b8",
      },
    },
  };

  // let dateSorted = currentData?.sort((a, b) => {
  //   return new Date(a.date) - new Date(b.date);
  // });
  let dateSorted = currentData.map((item) => {
    return item;
  });

  let dataSort = [...currentData].sort(
    (b, a) => new Date(a.date) - new Date(b.date)
  );
  // const unique = [];
  // const uniqueArr = dateSorted.filter((element) => {
  //   const isDuplicate = unique.includes(element.date);

  //   if (!isDuplicate) {
  //     unique.push(element.date);

  //     return true;
  //   }

  //   return false;
  // });

  

  //   // dateSorted.map((item) => {
  //   //   dateSorted.filter((arr) => {
  //   //     return arr.date === item.date;
  //   //   }).length;
  //   // })
  // );

  return (
    <Wrapper>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 20,
          }}
        >
          <Spin />
        </div>
      ) : (
        <Row gutter={[15, 15]}>
          {historyData.length == 0 ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: 20,
              }}
            >
              <Empty />
            </div>
          ) : (
            <>
              <Col span={24} className="graph-column-container">
                <Column {...config} />
              </Col>
              <Col span={24} className="Data-column-container">
                <Row className="data-row">
                  <Col span={12}>
                    <h5>Month TD</h5>
                  </Col>
                  <Col span={12} className="amount-container">
                    <h5>${parseFloat(payDate?.currentMonth).toFixed(2)}</h5>
                  </Col>
                </Row>
              </Col>
              <Col span={24} className="Data-column-container">
                <Row className="data-row">
                  <Col span={12}>
                    <h5> Year TD</h5>
                  </Col>
                  <Col span={12} className="amount-container">
                    <h5>${parseFloat(payDate?.currentYear).toFixed(2)}</h5>
                  </Col>
                </Row>
              </Col>
              <Col span={24} className="Data-column-container">
                <Row className="data-row">
                  <Col span={12}>
                    <h5> Last Year</h5>
                  </Col>
                  <Col span={12} className="amount-container">
                    <h5>${parseFloat(payDate?.lastYear).toFixed(2)}</h5>
                  </Col>
                </Row>
              </Col>
              <Col span={24} className="Data-column-container">
                <Row className="data-row">
                  <Col span={12}>
                    <h5>All Time </h5>
                  </Col>
                  <Col span={12} className="amount-container">
                    <h5>${parseFloat(payDate?.allTime).toFixed(2)}</h5>
                  </Col>
                </Row>
              </Col>
              <Col span={24} className="Pay-history-column-container">
                <h5> Pay History</h5>
              </Col>
              <Col span={24}>
                <Collapse>
                  {dataSort?.map((history, headerindex) => {
                    return (
                      <Panel
                        key={headerindex}
                        header={
                          <Row>
                            <Col span={24}>
                              <h5 className="collapse-ruppee-header">
                                ${parseFloat(history?.amount).toFixed(2)}
                              </h5>
                            </Col>
                            <Col span={24}>
                              <h5 className="collapse-date-header">
                                {history?.date}
                              </h5>
                            </Col>
                          </Row>
                        }
                      >
                        <Row className="sub-collapse-row">
                          <Col span={8} className="sub-collapse-name">
                            <p> {history?.name}</p>
                          </Col>
                          <Col span={8} className="sub-collapse-ruppee">
                            <p>${(history?.amount).toFixed(2)}</p>
                          </Col>
                          <Col span={8} className="sub-collapse-description">
                            <p>{history?.desc}</p>
                          </Col>
                        </Row>
                      </Panel>
                    );
                  })}
                </Collapse>
              </Col>
            </>
          )}
        </Row>
      )}
    </Wrapper>
  );
};

export default PayHistory;
